export const BASE_URL_QDC_CDN = 'https://api.qurancdn.com/api/qdc'; // should probably not be used. Use V4 SDK when https://github.com/quran/quran.com-api/issues/677 is resolved

export const READER_PAGES_COUNT = 604;

export const MAX_PAGE_ID = 604;
export const MIN_PAGE_ID = 1;

export const CURRENT_MUSHAF = 'hafs_v1';
